import {Component, Inject, OnInit} from '@angular/core';
import {FormControl, FormGroup, Validators} from '@angular/forms';
import {Loggedin} from '../authFilter/platformCentralAuth';
import {ActivatedRoute, Router, RouterStateSnapshot} from '@angular/router';
import {HttpClient} from '@angular/common/http';
import {ConfService} from '../conf.service';
import {MAT_DIALOG_DATA, MatDialog, MatDialogRef, MatSnackBar} from '@angular/material';
import {MyErrorStateMatcher} from '../signup/signup.component';
import {DialogData} from '../partner-onboard/partner-onboard.component';
import {Location} from '@angular/common';
// import {AuthService, GoogleLoginProvider} from 'angular4-social-login';
import {environment} from '../../environments/environment.prod';
import {KongService} from '../kong.service';
import {map} from "rxjs/operators";
import {Observable} from "rxjs";
import {state} from "@angular/animations";
import * as CryptoJS from 'crypto-js';
import {LeftpanelComponent} from '../leftpanel/leftpanel.component';

@Component({
    selector: 'app-login',
    templateUrl: './login.component.html',
    styleUrls: ['./login.component.css']
})
export class LoginComponent implements OnInit {
    title = 'login';
    loading: false;
    registerEmail: string;
    signInEmail: string;
    resetEmail: string;
    navigate: any;
    register = 'signin';
    emailSent: boolean;
    message: string;
    accept = false;
    checked = false;
    enablePassword = false;
    loginbuttonClick = false;
    corporateLoginFlag = false;
    corporateName = 'salapi';
    error = true;
    loginForm = new FormGroup({
        email: new FormControl(),
        password: new FormControl()
    });
    registerForm = new FormGroup({
        registerEmail: new FormControl()
    });
    resetForm = new FormGroup({
        resetEmail: new FormControl()
    });
    termsAndconditions: any;
    emailFormControl = new FormControl('', [
        Validators.required,
        Validators.email,
    ]);

    matcher = new MyErrorStateMatcher();
    user: any;
    appClientDetailsForPartner: any;
    appClientID: any;
    apiKeys: any;
    apiKeyData: any;
    apiKey: any;
    domainPartner: string;
    constructor(private authenticateComponent: Loggedin,
                private route: ActivatedRoute,
                private router: Router,
                private http: HttpClient,
                private confPost: ConfService,
                private kong: KongService,
                public platform: LeftpanelComponent,
                public dialog: MatDialog) {
    }

    // singIn(platform : string): void {
    //     platform = GoogleLoginProvider.PROVIDER_ID;
    //     this._socioAuthServ.signIn(platform).then(
    //         (response) => {
    //             this.user = response;
    //             this.confPost.registerEmail(this.user.email).subscribe(dat => {
    //                 const data = dat;
    //                 const body = data.body;
    //                 if (data.status === 200) {
    //                     this.router.navigate(['/signup'], { queryParams: {emailId: data.body['account_email'], token: data.body['token']}});
    //                 }
    //                 // else if (data.status === 208) {
    //                 //     this.message = 'Partner Account with this Email already exists.';
    //                 // }
    //             }, error => {
    //                 this.message = error.error.message;
    //                 // this.message = 'Error occurred while sending Partner Account Activation Link to this Email.';
    //             });                if (this.user) {
    //
    //             }
    //         }
    //     );
    // }
    // signOut(): void {
    //     this._socioAuthServ.signOut();
    //     this.user = null;
    // }
    get f() {
        return this.loginForm.controls;
    }

    corporateLogin(partner) {
        this.corporateLoginFlag = true;
    }
    signIn() {
        this.corporateLoginFlag = false;
    }

    openDialog() {
        // const dialogRef = this.dialog.open(TermsandConditionsComponent, {
        //     data: this.termsAndconditions
        // });
        //
        // dialogRef.afterClosed().subscribe(result => {
        //     this.accept = result;
        // });
    }

    ngOnInit() {
        this.domainPartner = localStorage.getItem('domainPartner');
        this.confPost.getTermsAndConditions().subscribe(data => {
            this.termsAndconditions = data;
        });
        // this.popitup('Login');
    }
    getAcceptValue(event) {
        this.accept = event.checked;
    }
    public getPage() {
        this.route.queryParams
            .subscribe(params => {
                this.navigate = params.return;
            });
        if (this.navigate) {
            // this.router.navigate([this.navigate]);
            this.router.navigate([this.navigate]);
            // window.location.href = this.navigate;
        } else {
            this.router.navigate(['/controlplane']);
           // this.router.navigate(['/my-account']);
            // window.location.href = '/controlplane';
            //  this.router.navigate(['/projects']);
        }
    }

    changeLogin(val) {
        //this.AcceptTermsCheck = true;
        this.emailSent = false;
        this.register = val;
    }

    getRegister() {
        this.emailSent = true;
        this.confPost.registerEmail(this.registerEmail).subscribe(data => {
            if (data.status === 200) {
                this.message = 'Your Partner Account has been created. Please verify it by clicking the activation link sent to your email.';
            } else if (data.status === 208) {
                this.message = 'Partner Account with this Email already exists.';
            }
        }, error => {
            this.emailSent = false;
            this.message = (error !== null && error !== undefined && error.error !== null && error.error !== undefined) ? ': ' + error.error.message : 'Error while registering email';
            // this.message = 'Error occurred while sending Partner Account Activation Link to this Email.';
        });
    }
    validateEmailCompany() {
        // this.enablePassword = true;
        if(this.signInEmail == 'sathish') {
            this.openFederatedLogin();
        } else {
            this.enablePassword = true;
        }

    }
    openFederatedLogin() {
        const that = this;
        const newwindow = window.open( 'https://iam.apiplatform.io/v1/authenticate?clientId=3tmudi495udl119lf378b3oklb',
            'apiPlatform', 'height=500, width=500');
        if (window.focus) { newwindow.focus(); }
        const eventMethod = window.addEventListener ? 'addEventListener' : 'attachEvent';
        const eventer = window[eventMethod];
        const messageEvent = eventMethod == 'attachEvent' ? 'onmessage' : 'message';
        // Listen to message from child window
        eventer(messageEvent, function(e) {
            // Check if origin is proper
            if ( e.origin === 'https://iam.apiplatform.io') {
                // To get JWT token use this  "e.data" and close the popup the window
               const data =  e.data.split('|');
                newwindow.close();
                that.validateToken(data[0]);
            }
        }, false);

    }
    validateToken(Token){
        const token = {
            "token": Token
        };
        const that = this;
        this.confPost.validateAuth(token).subscribe(auth => {
            if (auth) {
                localStorage.setItem('Auth', 'true');
                that.getPage();
            } else {

            }
        },error => {

            });
    }

    getReset() {
        this.emailSent = true;
        this.confPost.resetEmail(this.resetEmail).subscribe(data => {
                this.message = 'Reset password link has been sent to your email.';
        }, error => {
            this.emailSent = false;
            this.message = (error !== null && error !== undefined && error.error !== null && error.error !== undefined) ? ': ' + error.error.message : 'Error while resetting password link';
        });
    }
    getApiKeyForUser(signInEmail) {
        this.kong.getKeyAuthForConsumerInApiGatewayByNameOrId(signInEmail).subscribe(keys => {
            this.apiKeyData = keys;
            if (this.apiKeyData.data !== null && this.apiKeyData.data !== undefined && this.apiKeyData.data.length !== 0) {
                this.apiKeys = this.apiKeyData.data;
                this.apiKey = this.apiKeys[0].key;
                localStorage.setItem('apikey', this.apiKey);
            } else {
                this.platform.openSnackBar('There is no API key associated to your user credentials. Please get an API Key to securely access the APIs.', 'Info', {
                    duration: 15000,
                    verticalPosition: 'top',
                    horizontalPosition: 'center'
                });
            }
        }, error => {
            this.platform.openSnackBar('There is no API key associated to your user credentials. Please get an API Key to securely access the APIs.', 'Info', {
                duration: 15000,
                verticalPosition: 'top',
                horizontalPosition: 'center'
            });
        });
    }

    encrypt (salt, iv, passPhrase, plainText, keySize, iterationCount) {
        const key = CryptoJS.PBKDF2(passPhrase, CryptoJS.enc.Hex.parse(salt), { keySize: keySize, iterations: iterationCount });
        const encrypted = CryptoJS.AES.encrypt(
            plainText,
            key,
            { iv: CryptoJS.enc.Hex.parse(iv) });
        return encrypted.ciphertext.toString(CryptoJS.enc.Base64);
    }


    getLogin() {

        if (this.corporateLoginFlag) {
            const describeClientData = {
                'customerName': this.corporateName
            };
            this.confPost.getAppClientDetailsForPartner(describeClientData).subscribe(data => {
                this.appClientDetailsForPartner = data;
                const authUrl = environment.iamhost + '/v1/authenticate';
                this.appClientID = this.appClientDetailsForPartner.customerId;
                if (this.appClientID) {
                    this.router.navigate([authUrl], { queryParams: {clientId: this.appClientID}});
                }
            });
        } else {
            this.getApiKeyForUser(this.signInEmail);
            this.loginbuttonClick = true;
            this.error = false;
            if (this.loginForm.invalid) {
                return;
            }

            const iterationCount = 1000;
            let keySize = 128;
            keySize = keySize / 32;
            const passphrase = environment.cipheringPhrase;

            const iv = CryptoJS.lib.WordArray.random(128 / 8).toString(CryptoJS.enc.Hex);
            const salt = CryptoJS.lib.WordArray.random(128 / 8).toString(CryptoJS.enc.Hex);
            const cipherText = this.encrypt(salt, iv, passphrase, this.f.password.value, keySize, iterationCount);
            const loginPayload = {
                emailId: this.signInEmail,
                environment: this.domainPartner,
                password: cipherText,
                shash: salt,
                ralam: iv
            };
            // loginPayload.environment = this.domainPartner !== 'services' ? this.domainPartner : this._mFormGroup.value.environment;

            this.confPost.validateLogin(loginPayload).subscribe(data => {
                if (data.status === 200) {
                    if (data.body != null) {
                        localStorage.setItem('Auth', 'true');
                        localStorage.setItem('partnerId', data.body[0]._id);
                        localStorage.setItem('partner', data.body[0].partner);
                        localStorage.setItem('partnerKey', data.body[0].partnerKey);
                        localStorage.setItem('currentPlan', data.body[0].currentPlan);
                        localStorage.setItem('currentPlanDisplayName', data.body[0].currentPlanDisplayName);
                        localStorage.setItem('account', data.body[0].accounts[0].account_id);
                        localStorage.setItem('apikey', this.apiKey);
                        this.getPage();
                    } else {
                        this.error = true;
                        this.platform.openSnackBar("Invalid username or password.", 'Error', {
                            duration: 5000,
                            verticalPosition: 'top',
                            horizontalPosition: 'center'
                        });
                    }

                    // this.router.navigate(['/dataaccessapi']);
                }
            }, error => {
                this.error = true;
                this.platform.openSnackBar('Error while validating login credentials' + (error !== null && error !== undefined && error.error !== null && error.error !== undefined) ? ': ' + error.error.message : '', 'Error', {
                    duration: 5000,
                    verticalPosition: 'top',
                    horizontalPosition: 'center'
                });
            });
            /*this.authenticateComponent.login(this.f.email.value, this.f.password.value)
                .pipe(first())
                .subscribe(
                    data => {
                        /!* this.router.navigate([this.returnUrl]);*!/
                        window.location.href = 'http://localhost:4200/projects';
                    },
                    error => {
                        'Error Message';
                    });*/

        }


    }
}

// @Component({
//     selector: 'dialog-content-example-dialog',
//     templateUrl: 'terms-conditions.component.html',
//     styleUrls: ['terms-conditions.component.css']
// })
// export class TermsandConditionsComponent {
//     constructor(
//         public platform: LeftpanelComponent, public dialogRef: MatDialogRef<TermsandConditionsComponent>,
//         @Inject(MAT_DIALOG_DATA) public data: DialogData) {
//     }
// }
